const installMediaQueryWatcher = (mediaQuery, changedCallback) => {
  const mq = window.matchMedia(mediaQuery);
  mq.addEventListener('change', e => changedCallback(e.matches));
  changedCallback(mq.matches);
};

const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
  (events => {
    const loadScript = () => {
      events.forEach(type => window.removeEventListener(type, loadScript));
      clearTimeout(autoloadScript);

      const initScript = () => {
        const script = document.createElement('script');
        script.setAttribute('src', src);
        script.setAttribute('defer', '');
        script.onload = () => {
          window.Eurus.loadedScript.push(name);
          document.dispatchEvent(new CustomEvent(name + ' loaded'));
          onload();
        };

        document.head.appendChild(script);
      }

      if (requestVisualChange) {
        if (window.requestIdleCallback) {
          requestIdleCallback(initScript);
        } else {
          requestAnimationFrame(initScript);
        }
      } else {
        initScript();
      }
    };

    let autoloadScript;
    if (Shopify.designMode) {
      loadScript();
    } else {
      const wait = window.innerWidth > 767 ? 2000 : 5000;
      events.forEach(type => window.addEventListener(type, loadScript, {once: true, passive: true}));
      autoloadScript = setTimeout(() => {
        loadScript();
      }, wait);
    }
  })(['touchstart', 'mouseover', 'wheel', 'scroll', 'keydown']);
}

const getSectionInnerHTML = (html, selector = '.shopify-section') => {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

const xParseJSON = (jsonString) => {
  jsonString = String.raw`${jsonString}`;
  jsonString = jsonString.replace("\\","\\\\");

  return JSON.parse(jsonString);
}

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xDarkMode', {
      toggleThemeMode() {
        if (document.documentElement.classList.contains('dark')) {
          localStorage.eurus_theme = 0;
          document.documentElement.classList.remove('dark');
        } else {
          localStorage.eurus_theme = 1;
          document.documentElement.classList.add('dark');
        }
      }
    });

    Alpine.store('xHelper', {
      countdown(configs, callback) {
        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        const endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
        } else {
          startTime = new Date().getTime();
        }

        let x = setInterval(function() {
          let now = new Date().getTime();
          let distance = endTime - now;

          if (distance < 0 || startTime > now) {
            callback(false, 0, 0, 0, 0);
            clearInterval(x);
          } else {
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            callback(true, seconds, minutes, hours, days);
          }
        }, 1000);
      },
      canShow(configs) {
        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        const endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
        } else {
          startTime = new Date().getTime();
        }
        let now = new Date().getTime();
        let distance = endTime - now;

        if (distance < 0 || startTime > now) {
          return false;
        } 
        return true;
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('submitForm', () => ({ 
      submitFormLocalization(value, input) {
        document.getElementById(input).value = value;
        document.getElementById('localization_form').submit();
      }
    }))
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xCart', () => ({
      t: '',
      loading: false,
      updateItemQty(itemId) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        if (this.validateQty(qty)) {
          this._postUpdateItem(itemId, qty);
        }
      },
      minusItemQty(itemId) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        if (this.validateQty(qty)) {
          if (qty > 0) {
            qty -= 1;
            document.getElementById(`cart-qty-${itemId}`).value = qty;
          }

          this._postUpdateItem(itemId, qty);
        }
      },
      plusItemQty(itemId) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        if (this.validateQty(qty)) {
          if (qty >= 0) {
            qty += 1;
            document.getElementById(`cart-qty-${itemId}`).value = qty;
          }

          this._postUpdateItem(itemId, qty);
        }
      },
      removeItem(itemId) {
        this._postUpdateItem(itemId, 0, 0);
      },
      _postUpdateItem(itemId, qty, wait = 500) {
        clearTimeout(this.t);

        const func = () => {
          this.loading = true;
          let removeEl = document.getElementById(`remove-${itemId}`);
          if(removeEl){
            removeEl.style.display = 'none';
          }
          document.getElementById(`loading-${itemId}`).classList.remove('hidden');
          const sections = Alpine.store('xCartHelper').getSectionsToRender().map(s => s.id).join(',');
          let updateData = {
            'id': `${itemId}`,
            'quantity': qty,
            'sections': sections
          };

          fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateData)
          })
            .then(response => response.text())
            .then(state => {
              const parsedState = JSON.parse(state);

              if (parsedState.status == '422') {
                this._addErrorMessage(itemId, parsedState.message);
              } else {
                Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
                  const sectionElement = document.querySelector(section.selector);
                  if (sectionElement) {
                    if (parsedState.sections[section.id])
                      sectionElement.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
                  }
                }));
  
                if (parsedState.item_count > 0
                  && Alpine.store('xCartHelper').currentItemCount == parsedState.item_count) {
                  const errorMessage = window.Eurus.cart_quantity_error_html.replace(
                    '[quantity]',
                    parseInt(document.getElementById(`cart-qty-${itemId}`).value)
                  );
                  this._addErrorMessage(itemId, errorMessage);
                } else {
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                }

                Alpine.store('xCartHelper').currentItemCount = parsedState.item_count;
              }

              let loadingEl = document.getElementById(`loading-${itemId}`);
              let removeEl = document.getElementById(`remove-${itemId}`);
              if(removeEl){
                removeEl.style.display = 'block';
              }
              if (loadingEl) {
                loadingEl.classList.add('hidden');
              }
              this.loading = false;
            });
        }

        this.t = setTimeout(() => {
          func();
        }, wait);
      },
      _addErrorMessage(itemId, message) {
        const lineItemError = document.getElementById(`LineItemError-${itemId}`)
        lineItemError.classList.remove('hidden');
        lineItemError
          .getElementsByClassName('cart-item__error-text')[0]
          .innerHTML = message;
      },
      validateQty: function(number) {
        if((parseFloat(number) != parseInt(number)) && isNaN(number)) {
          return false
        }

        return true;
      }
    }));

    Alpine.store('xCartHelper', {
      currentItemCount: 0,
      updateCartNote: function(el) {
        const formData = JSON.stringify({ note: el.value });
        fetch(Shopify.routes.root + 'cart/update', {
          method:'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: formData
        });
      },
      validateCart: function(termEnabled, message) {
        if (!termEnabled || document.getElementById('x-cart-agree').checked) {
          let formData = {
            'attributes': {
              'collection-pagination': null             
            },
            'attributes': {
              'blog-pagination': null             
            }
          };

          fetch(Shopify.routes.root+'cart/update', {
            method:'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(formData)
          });

          document.getElementById('checkout-submit').click();
        } else {
          alert(message);
        }
      },
      getSectionsToRender() {
        const cartItemEl = document.getElementById('main-cart-items');
        if (cartItemEl) {
          const templateId = cartItemEl.closest('.shopify-section').id
                              .replace('cart-items', '')
                              .replace('shopify-section-', '');

          return [
            {
              id: templateId + 'cart-items',
              selector: '#main-cart-items'
            },
            {
              id: templateId + 'cart-footer',
              selector: '#main-cart-footer'
            },
            {
              id: templateId + 'cart-upsell',
              selector: '#main-cart-upsell'
            },
            {
              id: "cart-icon-bubble",
              selector: '#cart-icon-bubble'
            },
            {
              id: 'mobile-cart-icon-bubble',
              selector: '#mobile-cart-icon-bubble'
            }
          ];
        }

        return [
          {
            id: "cart-icon-bubble",
            selector: '#cart-icon-bubble'
          },
          {
            id: 'mobile-cart-icon-bubble',
            selector: '#mobile-cart-icon-bubble'
          },
          {
            id: 'cart-drawer',
            selector: '#CartDrawer'
          }
        ];
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xModalSearch', (type, desktopMaximunResults, mobileMaximunResults) => ({
      t: '',
      result: ``,
      query: '',
      cachedResults: [],
      openResults: false,
      open() {
        this.$refs.open_search.style.opacity = "1";
        this.$refs.open_search.style.maxHeight = "500px";
        this.$refs.open_search.classList.remove("overflow-hidden");
        this.$refs.open_search.classList.remove("hidden");
      },
      close() {
        this.$refs.open_search.style.opacity = "0";
        this.$refs.open_search.style.maxHeight = "0px";
        this.$refs.open_search.classList.add("overflow-hidden");
        this.$refs.open_search.classList.add("hidden");
      },
      keyUp() {
        this.query = this.$el.value;
        return () => {
          clearTimeout(this.t);
          this.t = setTimeout(() => {
            if (this.query != "") {
              this.getSearchResult(this.query);
            } else {
              this.result = "";
            }
          }, 300);
        };
      },
      getSearchResult(query) {
        this.openResults = true;
        const limit = window.innerWidth > 767 ? desktopMaximunResults : mobileMaximunResults;
        const queryKey = query.replace(" ", "-").toLowerCase() + '_' + limit;

        if (this.cachedResults[queryKey]) {
          this.result = this.cachedResults[queryKey];
          return;
        }

        fetch(`${Shopify.routes.root}search/suggest?q=${encodeURIComponent(query)}&${encodeURIComponent('resources[type]')}=${encodeURIComponent(type)}&${encodeURIComponent('resources[limit]')}=${encodeURIComponent(limit)}&section_id=predictive-search`)
          .then((response) => {
            return response.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const text = parser.parseFromString(response, 'text/html');
            this.result = text.querySelector("#shopify-section-predictive-search").innerHTML;
            this.cachedResults[queryKey] = this.result;
          })
          .catch((error) => {
            throw error;
          });
      }
    }));
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xHeaderMenu', {
      isSticky: false,
      stickyCalulating: false,
      isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
      sectionId: '',
      stickyType: 'none',
      lastScrollTop: 0,
      selectItem(el, isSub) {
        const itemSelector = isSub ? '.toggle-menu-sub' : '.toggle-menu';
        var items = isSub ? el.closest('.toggle-menu').querySelectorAll(itemSelector) : document.querySelectorAll(itemSelector);
        var currentItem = this.isTouch ? el.closest('.has-dropdown') : el;

        for (var i = 0; i < items.length; i++) {
          if (isSub) {
            items[i].style.display = "none";
          } else {
            items[i].style.maxHeight = "0px"; 
            items[i].style.opacity = "0";
            items[i].classList.add('max-h-0', 'overflow-hidden');
          }
        }

        let toggleMenu = currentItem.querySelector(itemSelector);
        if (toggleMenu) {
          if (isSub) {
            toggleMenu.style.display = 'block';
          } else {
            toggleMenu.style.maxHeight = '';
            toggleMenu.style.opacity = "1";
            toggleMenu.classList.remove('max-h-0', 'overflow-hidden');
          }
        }
      },
      hideMenu() {
        var items = document.querySelectorAll('.toggle-menu');
        for(var i = 0; i < items.length; i++) {  
          items[i].style.maxHeight = "0px";
          items[i].style.opacity = "0";
          items[i].classList.add("overflow-hidden");
        }
      },

      // start handle touch menu on the ipad
      touchItem(el, isSub = false) {
        const touchClass = isSub ? 'touched-sub' : 'touched';

        el.addEventListener("touchend", (e) => {
          if (el.classList.contains(touchClass)) {
            window.location.replace(el.getAttribute('href'));
          } else {
            e.preventDefault(); 
            var dropdown = document.querySelectorAll(`.${touchClass}`);
            for(var i = 0; i < dropdown.length; i++) { 
              dropdown[i].classList.remove(touchClass); 
            }

            el.classList.add(touchClass);
            this.selectItem(el, isSub);
          }
        });
      },

      // handle sticky header
      initSticky(el, sectionId, stickyType) {
        this.sectionId = sectionId;
        this.stickyType = stickyType;

        el.style.height = document.getElementById("sticky-header").offsetHeight + 'px';
      },
      handleAlwaysSticky() {
        const scrollPos = window.pageYOffset || document.documentElement.scrollTop;
        const stickyLine = document.getElementById(this.sectionId).offsetTop;

        if (scrollPos > stickyLine) this.addStickyHeader();
      },
      handelOnScrollSticky() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (Math.abs(scrollTop - this.lastScrollTop) > 10) {
          if (scrollTop < this.lastScrollTop)
            document.getElementById('sticky-header').classList.remove('header-up', 'opacity-0');
          else
            document.getElementById('sticky-header').classList.add('header-up');
          this.lastScrollTop = scrollTop;
        }
      },
      addStickyHeader() {
        let isMiniCartOpen = false;
        if (Alpine.store('xMiniCart').open && this.stickyType != 'on-scroll-up') {
          isMiniCartOpen = true;
          requestAnimationFrame(() => {
            Alpine.store('xMiniCart').hideCart();
          });
        }

        requestAnimationFrame(() => {
          let stickyEl = document.getElementById("sticky-header");
          stickyEl.classList.add("sticky-header", 'reduce-logo-size');

          this.isSticky = true;
        });

        requestAnimationFrame(() => {
          let stickyEl = document.getElementById("sticky-header");
          if (this.stickyType == 'on-scroll-up') {
            setTimeout(() => {
              stickyEl.classList.add('on-scroll-up-animation');
            }, 500);
          }
          if (this.stickyType == 'always'
            || this.stickyType == 'reduce-logo-size') stickyEl.classList.add('always-animation');
        });

        if (isMiniCartOpen) {
          requestAnimationFrame(() => {
            Alpine.store('xMiniCart').openCart();
          });
        }
      },
      removeStickyHeader() {
        this.isSticky = false;

        requestAnimationFrame(() => {
          document.getElementById("sticky-header").classList
            .remove('sticky-header', 'reduce-logo-size', 'always-animation', 'on-scroll-up-animation');
          this.reCalculateHeaderHeight();
        });
      },
      handleChangeThemeMode() {
        this.reCalculateHeaderHeight();
      },
      reCalculateHeaderHeight() {
        document.getElementById("x-header-container").style.height
          = document.getElementById("sticky-header").offsetHeight + 'px';
      },
      addTransparentHover(el) {
        if (window.innerWidth < 1024) return;

        el.classList.add('sticky-header-active');
      },
      removeTransparentHover(el) {
        if (window.innerWidth < 1024) return;
        
        el.classList.remove('sticky-header-active');
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xMobileNav', {
      show: false,
      loading: false,
      currentMenuLinks: [],
      open() {
        this.show = true;
        Alpine.store('xPopup').open = true;
      },
      close() {
        this.show = false;
        Alpine.store('xPopup').open = false;
      },
      setActiveLink(linkId) {
        this.currentMenuLinks.push(linkId);
      },
      removeActiveLink(linkId) {
        const index = this.currentMenuLinks.indexOf(linkId);
        if (index !== -1) {
          this.currentMenuLinks.splice(index, 1);
        }
      },
      resetMenu() {
        this.currentMenuLinks = [];
      },
      scrollTop() { 
        document.getElementById('menu-navigation').scrollTop = 0; 
      }
    });

    Alpine.store('xPopup', {
      open: false
    }); 

    Alpine.store('xShowCookieBanner', {
      show: false
    });

    Alpine.store('xMiniCart', {
      open: false,
      type: '',
      openCart() {
        if (window.location.pathname != '/cart') {        
          requestAnimationFrame(() => {
            document.getElementById('sticky-header').classList.remove('on-scroll-up-animation');

            if (window.innerWidth < 768 || this.type == "drawer") {
              Alpine.store('xPopup').open = true;
            }

            requestAnimationFrame(() => {
              document.getElementById('sticky-header').classList.remove('header-up');
              this.open = true;
            });
            
            if (Alpine.store('xHeaderMenu').stickyType == 'on-scroll-up') {
              setTimeout(() => {
                requestAnimationFrame(() => {
                  document.getElementById('sticky-header').classList.add('on-scroll-up-animation');
                });
              }, 200);
            }
          });
        }
      },
      hideCart() {
        requestAnimationFrame(() => {
          this.open = false;
          Alpine.store('xPopup').open = false;
        });
      }
    });

    Alpine.store('xModal', {
      activeElement: "",
      setActiveElement(element) {
        this.activeElement = element;
      },
      focus(container, elementFocus) {
        Alpine.store('xFocusElement').trapFocus(container, elementFocus);
      },
      removeFocus() {
        const openedBy = document.getElementById(this.activeElement);
        Alpine.store('xFocusElement').removeTrapFocus(openedBy);
      }
    });

    Alpine.store('xFocusElement', {
      focusableElements: ['button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'],
      listeners: {},
      trapFocus(container, elementFocus) {
        if ( window.innerWidth < 1025 ) return;

        let c = document.getElementById(container);
        let e = document.getElementById(elementFocus);
        this.listeners = this.listeners || {};
        const elements = Array.from(c.querySelectorAll(this.focusableElements));
        var first = elements[0];
        var last = elements[elements.length - 1];
        
        this.removeTrapFocus();
        
        this.listeners.focusin = (event)=>{
          if (
            event.target !== c &&
            event.target !== last &&
            event.target !== first
          ){
            return;
          }
          document.addEventListener('keydown', this.listeners.keydown);
        };

        this.listeners.focusout = () => {
          document.removeEventListener('keydown', this.listeners.keydown);
        }

        this.listeners.keydown = (e) =>{
          if (e.code.toUpperCase() !== 'TAB') return;
  
          if (e.target === last && !e.shiftKey) {
            e.preventDefault();
            first.focus();
          }
  
          if ((e.target === first || e.target == c) && e.shiftKey) {
            e.preventDefault();
            last.focus();
          }
        }
        document.addEventListener('focusout', this.listeners.focusout);
        document.addEventListener('focusin', this.listeners.focusin);
        e.focus();
      },
      removeTrapFocus(elementToFocus = null) {
        if ( window.innerWidth < 1025 ) return;

        document.removeEventListener('focusin', ()=>{
          document.addEventListener('keydown', this.listeners.focusin);
        });
        document.removeEventListener('focusout', ()=>{
          document.removeEventListener('keydown', this.listeners.focusout);
        });
        document.removeEventListener('keydown', this.listeners.keydown);
        if (elementToFocus) elementToFocus.focus();
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xCartAnalytics', {
      viewCart() {
        fetch(
          '/cart.js'
        ).then(response => {
          return response.text();
        }).then(cart => {
          cart = JSON.parse(cart);
          if (cart.items.length > 0) {
            Shopify.analytics.publish('view_cart', {'cart': cart});
          }
        });
      }
    });

    Alpine.store('xShopifyPaymentBtn', {
      load(e) {
        (events => {
          const init = () => {
            events.forEach(type => window.removeEventListener(type, init));

            e.innerHTML = e.getAttribute('data-shopify-payment-button');
            e.removeAttribute('data-shopify-payment-button');
            Shopify.PaymentButton.init();
          }
        
          events.forEach(type => window.addEventListener(type, init, {once: true, passive: true}));
        })(['touchstart', 'mouseover', 'wheel', 'scroll', 'keydown']);
      },
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xCustomerEvent', {
      fire(eventName, el, data) {
        if (Shopify.designMode) return;
        
        const formatedData = data ? data : xParseJSON(el.getAttribute('x-customer-event-data'));
        Shopify.analytics.publish(eventName, formatedData);
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xSplide', {
      load(el, configs) {
        const initSlider = () => {
          const id = el.getAttribute("id");

          if(configs.classes != undefined) {
            if (!configs.classes.arrow) configs.classes.arrow = "arrow w-8 h-8 p-2 absolute z-10 top-1/2 -translate-y-1/2 hidden md:flex items-center justify-center";
            if (!configs.classes.next) configs.classes.next = "right-0";
            if (!configs.classes.prev) configs.classes.prev = "-rotate-180";
          }
          let splide = new Splide("#" + id, configs);

          if (configs.thumbs) {
            let thumbsRoot = document.getElementById(configs.thumbs);
            let thumbs = thumbsRoot.getElementsByClassName('x-thumbnail');
            let current;
            let _this = this;

            for (let i=0;i<thumbs.length;i++) {
              thumbs[i].addEventListener('click', function () {
                _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction);
                splide.go(i);
              });
            }
            splide.on('mounted move', function () {
              let thumbnail = thumbs[splide.index];
            
              if (thumbnail) {
                if (current) {
                  current.classList.add('opacity-30');
                }
                thumbnail.classList.remove('opacity-30');
                current = thumbnail;
                _this.moveThumbnail(splide.index, thumbnail, thumbsRoot, configs.thumbs_direction);
              }
            });
          }

          if (configs.hotspot) {
            let hotspotRoot = document.getElementById(configs.hotspot);
            let hotspots = hotspotRoot.getElementsByClassName('x-hotspot');
            let current;

            for (let i=0;i<hotspots.length;i++) {
              hotspots[i].addEventListener('mouseover', function () {
                splide.go(i);
              });
              hotspots[i].addEventListener('focus', function () {
                splide.go(i);
              });
            }

            splide.on('mounted move', function () {
              let hotspot = hotspots[splide.index];
            
              if (hotspot) {
                if (current) {
                  current.classList.remove('active-hotspot');
                }
                hotspot.classList.add('active-hotspot');
                current = hotspot;
              }
            });
          }

          if (configs.progressBar) {
            var bar = splide.root.querySelector( '.splide-progress-bar' );
            splide.on( 'mounted move', function () {
              var end  = splide.Components.Controller.getEnd() + 1;
              if ( (end - configs.progressBar) == splide.index) {
                var rate = 1;
              } else {
                var rate = Math.min( ( splide.index + 1 ) / end, 1 );
              }
              bar.style.width = String( 100 * rate ) + '%';
            } );
          }

          if (configs.events) {
            configs.events.forEach((e) => {
              splide.on(e.event, e.callback);
            });
          }

          
          el.splide = splide;
          splide.mount();
        }

        if (!window.Eurus.loadedScript.includes('slider')) {
          deferScriptLoad('slider', window.Eurus.sliderScript, initSlider, true);
        } else {
          initSlider();
        }
      },
      moveThumbnail(index, thumbnail, thumbsRoot, direction) {
        if (direction == 'vertical') {
          setTimeout(() => {
            thumbsRoot.scrollTop = (index+1) * thumbnail.offsetHeight - thumbsRoot.offsetHeight*0.5 + thumbnail.offsetHeight*0.5 + index*12;
          },50);
        } else {
          thumbsRoot.scrollLeft = (index-2) * thumbnail.offsetWidth;
        }
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xParallax', () => ({
      debounce(func, wait) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
              timeout = null;
              func.apply(context, args);
            };
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      },
      load() {
        if ("IntersectionObserver" in window && 'IntersectionObserverEntry' in window) {
          const observerOptions = {
            root: null,
            rootMargin: '0px 0px',
            threshold: 0
          };

          var observer = new IntersectionObserver(handleIntersect, observerOptions);
          var el;
          function handleIntersect(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                el = entry.target;
                window.addEventListener('scroll', parallax, {passive: true, capture: false});
              } else {
                window.removeEventListener('scroll', parallax, {passive: true, capture: false});
              }
            });
          }

          observer.observe(this.$el);
          
          var parallax = this.debounce(function() {
            var rect = el.getBoundingClientRect();
            var speed = (window.innerHeight / el.parentElement.offsetHeight) * 20;
            var shiftDistance = (rect.top - window.innerHeight) / speed;
            var maxShiftDistance = el.parentElement.offsetHeight / 11;
            if (shiftDistance + maxShiftDistance < 0) {
              shiftDistance = -maxShiftDistance;
            }
            el.style.transform = 'translate3d(0, '+ shiftDistance +'px, 0)';
          }, 10);
        }
      }
    }));
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xProductCart', () => ({
      loading: false,
      errorMessage: false,
      buttonSubmit: "",
      addToCart(e) {
        e.preventDefault();
        let formData = new FormData(this.$refs.product_form);
        this.loading = true;

        formData.append(
          'sections',
          Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        fetch('/cart/add', {
          method:'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        }).then(reponse => {
          return reponse.json();
        }).then((response) => {
          if (response.status == '422') {
            this.errorMessage = true;
            if(this.$refs.error_message){
              this.$refs.error_message.textContent = response.description;
            }
            return;
          } else {
            document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));

            Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
              const sectionElement = document.querySelector(section.selector);
              if (sectionElement) {
                if (response.sections[section.id])
                  sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
              }
            }));

            Alpine.store('xQuickView').show = false;
            Alpine.store('xPopup').open = false;
            Alpine.store('xMiniCart').openCart();
            
            Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
          }
        }).catch((error) => {
          console.error('Error:', error);
        }).finally(() => {
          this.loading = false;
        }) 
      }
    }))
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xVariantSelect', (
      sectionId,
      unavailableText,
      variantUnavailableText,
      productUrl,
      productId
    ) => ({
      variants: null,
      currentVariant: {},
      options: [],
      cachedResults: [],
      init() {
        this.variants = xParseJSON(this.$el.getAttribute('x-variants-data'));

        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
          Alpine.store('xUpdateVariantQuanity').updateQuantity(sectionId, productUrl, this.currentVariant.id);
        });
      },
      initMedia(inputType) {
        this.updateOptions(inputType);
        this.updateMasterId();
        this.updateMedia();
      },
      updateVariantSelector(inputType, productPage) {
        this.updateOptions(inputType);
        this.updateMasterId();
        this.updateVariantStatuses(inputType);

        if (!this.currentVariant) {
          this.setUnavailable();
          return;
        }

        if (productPage) {
          window.history.replaceState({}, '', `?variant=${this.currentVariant.id}`);
        }

        this.updateVariantInput();
        this.updateMedia();
        this.updateProductForms();
        this.setAvailable();
        Alpine.store('xPickupAvailable').updatePickUp(sectionId, this.currentVariant.id);

        const cacheKey = sectionId + '-' + this.currentVariant.id;
        if (this.cachedResults[cacheKey]) {
          const html = this.cachedResults[cacheKey];

          this.renderPriceProduct(html);
          this.renderProductBadges(html);
          this.renderInventoryStatus(html);
          this.renderBuyButtons(html);
          Alpine.store('xUpdateVariantQuanity').render(html, sectionId);
        } else {
          const variantId = this.currentVariant.id;
          fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              if (variantId == this.currentVariant.id
                && html.getElementById(`x-product-template-${productId}-${sectionId}`)) {
                this.renderPriceProduct(html);
                this.renderProductBadges(html);
                this.renderInventoryStatus(html);
                this.renderBuyButtons(html);
                Alpine.store('xUpdateVariantQuanity').render(html, sectionId);

                this.cachedResults[cacheKey] = html
              }
            });
        }
      },
      updateVariantStatuses(inputType) {
        const variantEl = document.getElementById("variant-update-" + sectionId);
        const selectedOptionOneVariants = this.variants.filter(variant => variantEl.querySelector(':checked').value === variant.option1);
        const inputWrappers = [...variantEl.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
          const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
          const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue, inputType)
        });
      },
      setInputAvailability(listOfOptions, listOfAvailableOptions, inputType) {
        if (inputType == "radio") {
          listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
              input.classList.remove('disabled');
            } else {
              input.classList.add('disabled');
            }
          });
        } else {
          listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
              input.innerText = input.getAttribute('value');
            } else {
              input.innerText = variantUnavailableText.replace('[value]', input.getAttribute('value'));
            }
          });
        }
      },
      updateOptions(inputType) {
        if (inputType == "radio") {
          const fieldsets = Array.from(this.$refs.element_variant.querySelectorAll('fieldset'));
          this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          });
        } else {
          this.options = Array.from(this.$refs.element_variant.querySelectorAll('select'), (select) => select.value);
        }
      },
      renderInventoryStatus(html) {
        const destination = document.getElementById('block-inventory-' + sectionId);
        const source = html.getElementById('block-inventory-' + sectionId);
        if (source && destination) destination.innerHTML = source.innerHTML;
      },
      updateMedia() {
        if (this.currentVariant.featured_image != null) {
          let slideVariant = document.getElementsByClassName(this.currentVariant.featured_media.id + '-' + sectionId);
          let index = parseInt(slideVariant[0].getAttribute('index'));

          let splideEl = document.getElementById("x-product-" + sectionId);
          if (splideEl.splide && this.currentVariant.featured_image != null) {
            splideEl.splide.go(index - 1)
          } else {
            document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, () => {
              splideEl.splide.go(index - 1)
            });
          }

          let activeEL = document.getElementById('postion-image-' + sectionId + '-' + this.currentVariant.featured_media.id);
          if (!activeEL) return;

          let stackedEL = document.getElementById('stacked-' + sectionId);
          stackedEL.prepend(activeEL);
        }
      },
      updateMasterId() {
        this.currentVariant = this.variants.find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });
      },
      updateVariantInput() {
        const input = document.getElementById("update-variant-" + sectionId);
        if (!input) return;

        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      },
      updateProductForms() {
        const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}`);
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      },
      renderPriceProduct(html) {
        const destination = document.getElementById('price-' + sectionId);
        const source = html.getElementById('price-' + sectionId);

        if (source && destination) destination.innerHTML = source.innerHTML;
      },
      renderProductBadges(html) {
        const destination = document.getElementById('x-badges-' + sectionId);
        const source = html.getElementById('x-badges-'+ sectionId);
        
        if (source && destination) destination.innerHTML += source.innerHTML;
      },
      renderBuyButtons(html) {
        const atcDestination = document.getElementById('x-atc-button-' + sectionId);
        const atcSource = html.getElementById('x-atc-button-' + sectionId);
        if (atcSource && atcDestination) atcDestination.innerHTML = atcSource.innerHTML;

        const paymentButtonDestination = document.getElementById('x-payment-button-' + sectionId);
        const paymentButtonSource = html.getElementById('x-payment-button-' + sectionId);
        if (paymentButtonSource && paymentButtonDestination) {
          if (paymentButtonSource.classList.contains('hidden')) {
            paymentButtonDestination.classList.add('hidden');
          } else {
            paymentButtonDestination.classList.remove('hidden');
          }
        }

        if (this.currentVariant.available) {
          atcDestination.removeAttribute('disabled');
        } else {
          atcDestination.setAttribute('disabled', 'disabled');
        }
      },
      setBuyButtonUnavailable() {
        const productForm = document.getElementById('product-form-' + sectionId);
        if (!productForm) return;

        const addButton = productForm.querySelector('#x-atc-button-' + sectionId);
        if (!addButton) return;

        addButton.setAttribute('disabled', 'disabled');
        const addButtonText = addButton.querySelector('.x-atc-text');
        addButtonText.textContent = unavailableText;
      },
      setUnavailable() {
        const price = document.getElementById(`price-` + sectionId);
        if (price) price.classList.add('hidden');

        const inventory = document.getElementById(`block-inventory-` + sectionId);
        if (inventory) inventory.classList.add('hidden');

        const badges = document.getElementById(`x-badges-` + sectionId);
        if (badges) badges.classList.add('hidden');

        const pickup = document.getElementById(`pickup-` + sectionId);
        if (pickup) pickup.classList.add('hidden');

        const quantity = document.getElementById('x-quantity-' + sectionId);
        if (quantity) quantity.classList.add('unavailable');

        this.setBuyButtonUnavailable();
      },
      setAvailable() {
        const price = document.getElementById(`price-` + sectionId);
        if (price) price.classList.remove('hidden');

        const inventory = document.getElementById(`block-inventory-` + sectionId);
        if (inventory) inventory.classList.remove('hidden');

        const badges = document.getElementById(`x-badges-` + sectionId);
        if (badges) badges.classList.remove('hidden');

        const pickup = document.getElementById(`pickup-` + sectionId);
        if (pickup) pickup.classList.remove('hidden');

        const quantity = document.getElementById('x-quantity-' + sectionId);
        if (quantity) quantity.classList.remove('unavailable');
      }
    }))
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xPickupAvailable', {
      updatePickUp(id, variantId) {
        const container = document.getElementsByClassName('pick-up-'+ id)[0];
        if (!container) return;

        fetch(window.Shopify.routes.root + `variants/${variantId}/?section_id=pickup-availability`)
          .then(response => response.text())
          .then(text => {
            const pickupAvailabilityHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');

            container.innerHTML = pickupAvailabilityHTML.innerHTML;
          })
          .catch(e => {
            console.error(e);
          }); 
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xUpdateVariantQuanity', {
      updateQuantity(sectionId, productUrl, currentVariant) {
        const url = currentVariant ? `${productUrl}?variant=${currentVariant}&section_id=${sectionId}` :
                      `${productUrl}?section_id=${sectionId}`;

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            let html = new DOMParser().parseFromString(responseText, 'text/html');
            this.render(html, sectionId);
          });
      },
      render(html, sectionId) {
        const destination = document.getElementById('x-quantity-' + sectionId);
        const source = html.getElementById('x-quantity-'+ sectionId);
        if (source && destination) destination.innerHTML = source.innerHTML;
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xVideo', {
      ytIframeId: 0,
      vimeoIframeId: 0,
      externalListened: false,
      play(el) {
        let video = el.getElementsByClassName('video')[0];
        if (video) {
          if (video.tagName == 'IFRAME') {
            this.externalPostCommand(video, 'play');
          } else if (video.tagName == 'VIDEO') {
            video.play();
          }
        }
      },
      pause(el) {
        let video = el.getElementsByClassName('video')[0];
        if (video) {
          if (video.tagName == 'IFRAME') {
            this.externalPostCommand(video, 'pause');
          } else if (video.tagName == 'VIDEO') {
            video.pause();
          }
        }
      },
      mp4Thumbnail(el) {
        const videoContainer = el.closest('.external-video');
        const imgThumbnail = videoContainer.getElementsByClassName('img-thumbnail')[0];
        const buttonPlay = videoContainer.getElementsByClassName('button-play')[0];
        const video = videoContainer.getElementsByClassName('video')[0];
        if (imgThumbnail) {
          imgThumbnail.classList.add('hidden');
        }
        if (buttonPlay) {
          buttonPlay.classList.add('hidden');
        }
        if (video) {
          video.setAttribute("controls",'');
        }
        this.play(videoContainer);
      },
      externalLoad(el, host, id, loop, title, controls = 1) {
        let src = '';
        let pointerEvent = '';
        if (host == 'youtube') {
          src = `https://www.youtube.com/embed/${id}?mute=1&playlist=${id}&autoplay=1&playsinline=1&enablejsapi=1&modestbranding=1&rel=0&controls=${controls}&showinfo=${controls}`;
        } else {
          src = `https://player.vimeo.com/video/${id}?muted=1&autoplay=1&playsinline=1&api=1&controls=${controls}`;
        }

        if (controls == 0) {
          pointerEvent = " pointer-events-none";
        }
        requestAnimationFrame(() => {
          const videoContainer = el.closest('.external-video');
          videoContainer.innerHTML = `<iframe data-video-loop="${loop}" class="iframe-video absolute w-full h-full video top-1/2 -translate-y-1/2 ${ pointerEvent }"
            frameborder="0" host="${host}" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen playsinline
            src="${src}" title="${title}"></iframe>`;

          videoContainer.querySelector('.iframe-video').addEventListener("load", () => {
            setTimeout(() => {
              this.play(videoContainer);

              if (host == 'youtube') {
                this.ytIframeId++;
                videoContainer.querySelector('.iframe-video').contentWindow.postMessage(JSON.stringify({
                  event: 'listening',
                  id: this.ytIframeId,
                  channel: 'widget'
                }), '*');
              } else {
                this.vimeoIframeId++;
                videoContainer.querySelector('.iframe-video').contentWindow.postMessage(JSON.stringify({
                  method: 'addEventListener',
                  value: 'finish'
                }), '*');
              }
            }, 100);
          });
        });

        this.externalListen();
      },
      renderVimeoFacade(el, id, options) {
        fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${id}&width=${options.width}`)
          .then(reponse => {
            return reponse.json();
          }).then((response) => {
            const html = `
              <picture>
                <img src="${response.thumbnail_url}" loading="lazy" class="w-full h-full object-cover" alt="${options.alt}" width="${response.width}" height="${response.height}"/>
              </picture>
            `;
            
            requestAnimationFrame(() => {
              el.innerHTML = html;
            });
          });
      },
      externalListen() {
        if (!this.externalListened) {
          window.addEventListener('message', (event) => {
            var iframes = document.getElementsByTagName('IFRAME');

            for (let i = 0, iframe, win, message; i < iframes.length; i++) {
              iframe = iframes[i];

              if (iframe.getAttribute('data-video-loop') !== 'true') continue;

              // Cross-browser way to get iframe's window object
              win = iframe.contentWindow || iframe.contentDocument.defaultView;

              if (win === event.source) {
                if (event.origin == 'https://www.youtube.com') {
                  message = JSON.parse(event.data);
                  if (message.info && message.info.playerState == 0) {
                    this.play(iframe.parentNode);
                  }
                }

                if (event.origin == 'https://player.vimeo.com') {
                  message = JSON.parse(event.data);
                  if (message.event == "finish") {
                    this.play(iframe.parentNode);
                  }
                }
              }
            }
          });

          this.externalListened = true;
        }
      },
      externalPostCommand(iframe, cmd) {
        const host = iframe.getAttribute('host');
        const command = host == 'youtube' ? {
          "event": "command",
          "func": cmd + "Video"
        } : {
          "method": cmd,
          "value": "true"
        };

        iframe.contentWindow.postMessage(JSON.stringify(command), '*');
      },
    });

    Alpine.data('xProductMedia', (settings) => ({
      thumbnailOnMouseDown: false,
      thumbnailOfset: 0,
      thumbnailScrollOfset: 0,
      thumbnailGrabbingClass: '',
      zoomIsOpen: false,
      productMediaIsOpen: '',
      videoExternalListened: false,
      thumbnailHandleMouseDown(e) {
        this.thumbnailOnMouseDown = true;
        this.thumbnailGrabbingClass = 'cursor-grabbing';
        if (settings.thumbnail_direction == 'horizontal') {
          this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
          this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
        } else {
          this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
          this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
        }
      },
      thumbnailHandleMouseMove(e) {
        if(!this.thumbnailOnMouseDown) return;
        e.preventDefault();
        if (settings.thumbnail_direction == 'horizontal') {
          const x = e.pageX - this.$refs.thumbnail.offsetLeft;
          const walk = (x - this.thumbnailOfset) * 2; 
          this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
        }
        else {
          const y = e.pageY - this.$refs.thumbnail.offsetTop;
          const walk = (y - this.thumbnailOfset) * 2; 
          this.$refs.thumbnail.scrollTop = this.thumbnailScrollOfset - walk;
        }
      },
      thumbnailHandleMouseLeave() {
        this._thumbnailRemoveGrabing();
      },
      thumbnailHandleMouseUp() {
        this._thumbnailRemoveGrabing();
      },
      _thumbnailRemoveGrabing() {
        this.thumbnailOnMouseDown = false;
        this.thumbnailGrabbingClass = 'md:cursor-grab';
      },
      zoomOpen(position) {
        this.zoomIsOpen = true;
        Alpine.store('xPopup').open = true;
        setTimeout(() => {
          document.getElementById(position + '-image-zoom-' + settings.section_id).scrollIntoView()
        }, 10);
        Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
      },
      zoomClose() {
        this.zoomIsOpen = false;
        Alpine.store('xPopup').open = false;
      },
      
      videoHandleIntersect() {
        if (settings.video_autoplay) {
          Alpine.store('xVideo').play(this.$el);
        }
      },
      productModelInit() {
        window.Shopify.loadFeatures([
          {
            name: 'shopify-xr',
            version: '1.0',
            onLoad: this._productModelSetupShopifyXR,
          },
        ]);
      },
      _productModelSetupShopifyXR() {
        const setup = () => {
          document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
            window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
            modelJSON.remove();
          });
          window.ShopifyXR.setupXRElements();
        }

        if (!window.ShopifyXR) {
          document.addEventListener('shopify_xr_initialized', () => {
            setup();
          });
          return;
        }
    
        setup();
      },
      productModelLoadMedia() {
        let container = this.$el.parentNode;
        const content = document.createElement('div');
        content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));

        this.$el.classList.add('hidden');
        container.appendChild(content.querySelector('model-viewer'));

        this._productModelLoadViewerUI();
      },
      productModelPauseViewer() {
        if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
      },
      _productModelLoadViewerUI() {
        window.Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this._productModelSetupViewerUI.bind(this),
          },
        ]);
      },
      _productModelSetupViewerUI(errors) {
        if (errors) return;

        this.$el.parentNode.modelViewerUI
          = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); 
      }
    }));
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xShippingPolicy', (url) => ({
      show: false,
      htmlInner: '',
      loadShipping() {
        this.show = true;
        Alpine.store('xPopup').open = true;
        fetch(url)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const text = parser.parseFromString(data, 'text/html');
            this.htmlInner = text.querySelector('.shopify-policy__container').innerHTML;
          })
      },
      shippingFocus() {
        Alpine.store('xFocusElement').trapFocus('ShippingPolicyPopup','CloseShopping');
      },
      shippingRemoveFocus() {
        const activeElement = document.getElementById('LoadShoppingPolicy');
        Alpine.store('xFocusElement').removeTrapFocus(activeElement);
      }
    }))
  })
});
